// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ak-J3b","absoluteTop":"_1UjrDm","absoluteText":"Q-bZP6","container":"W9GWhV","bird":"_25oUOv","shine-lines":"_3ecGsk"};